function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Camera({
  width = 35,
  height = 35,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.491 7.046c.587-1.065 1.224-1.777 2.17-2.154 1.734-.69 7.944-.69 9.677 0 .946.377 1.584 1.089 2.17 2.154l.66 1.264.041.066.056.077c.3.327.804.525 1.136.525a5.683 5.683 0 015.683 5.682v8.45a7.25 7.25 0 01-7.248 7.249H10.165a7.248 7.248 0 01-7.248-7.248V14.66A5.683 5.683 0 018.6 8.978c.33 0 .834-.198 1.135-.525a.363.363 0 00.024-.03l.075-.114.657-1.263zm12.101 1.055c-.364-.662-.694-1.03-1.063-1.176l-.174-.058c-1.5-.424-6.721-.405-7.885.058-.369.147-.698.514-1.062 1.176l-.561 1.085-.138.25c-.116.192-.231.354-.363.497-.739.803-1.831 1.233-2.746 1.233l-.24.008a3.496 3.496 0 00-3.256 3.486v8.45a5.06 5.06 0 005.06 5.061h14.672a5.062 5.062 0 005.06-5.06V14.66a3.495 3.495 0 00-3.495-3.494l-.254-.01a3.929 3.929 0 01-2.493-1.224 3.02 3.02 0 01-.42-.598l-.17-.318-.472-.915z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M25.528 12.396a1.458 1.458 0 01.17 2.907l-.17.01a1.458 1.458 0 01-.183-2.907l.183-.01z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.77 19.145a5.73 5.73 0 1111.46 0 5.73 5.73 0 11-11.46 0zm9.272 0a3.542 3.542 0 10-7.083 0 3.542 3.542 0 007.083 0z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Camera.js.map